export default "__VITE_ASSET__3749d996__"